const needCreateBrandInfo = `
## Definissez votre marque

Définissez d'abord le détail de votre marque, vous pourrez ensuite définir le contenu de vos écrans.
Si vous êtes un utilisateur unique, vous pouvez utiliser votre nom et la marque.

Remplissez le formulaire ci-dessous et cliquez sur "Créer".
`

module.exports = {
  needCreateBrandInfo: needCreateBrandInfo,
}
